import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["defaultRowSortOrder", "rowSortOrder", "onRowSortOrderChange", "enableNeutralRowSorting"];
import { useCallback, useState } from 'react';
import { TABLE_SORTING_DIRECTION_ASC, TABLE_SORTING_DIRECTION_DESC } from '../../Table/constants';
export var useDataTableRowSorting = function useDataTableRowSorting(columnsSafe, _ref) {
  var defaultRowSortOrder = _ref.defaultRowSortOrder,
      rowSortOrder = _ref.rowSortOrder,
      onRowSortOrderChange = _ref.onRowSortOrderChange,
      enableNeutralRowSorting = _ref.enableNeutralRowSorting,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(defaultRowSortOrder || []),
      _useState2 = _slicedToArray(_useState, 2),
      rowSortOrderInternal = _useState2[0],
      setRowSortOrderInternal = _useState2[1];

  var rowSortOrderActual = rowSortOrder || rowSortOrderInternal;
  var onRowSortOrderChangeInternal = useCallback(function (order) {
    if (!rowSortOrder) {
      setRowSortOrderInternal(order);
    }

    if (onRowSortOrderChange) {
      onRowSortOrderChange(order);
    }
  }, [onRowSortOrderChange, rowSortOrder, setRowSortOrderInternal]);
  var onHeadCellClick = useCallback(function (event) {
    var node = event.currentTarget;
    var columnId = node.getAttribute('data-columnid');
    var sortable = node.getAttribute('data-sortable');

    if (!sortable || !columnId) {
      return;
    }

    var column = columnsSafe.find(function (columnItem) {
      return columnItem.id === columnId;
    });

    if (!column) {
      return;
    }

    if (column.headCellProps && column.headCellProps.onClick) {
      column.headCellProps.onClick(event);

      if (event.isPropagationStopped()) {
        return;
      }
    }

    var direction = '';

    if (rowSortOrderActual.length && rowSortOrderActual[0][0] === columnId) {
      direction = rowSortOrderActual[0][1];
    }

    var nextOrder = [];

    if (direction === '') {
      nextOrder = [[columnId, TABLE_SORTING_DIRECTION_ASC]];
    } else if (direction === TABLE_SORTING_DIRECTION_ASC) {
      nextOrder = [[columnId, TABLE_SORTING_DIRECTION_DESC]];
    } else {
      if (enableNeutralRowSorting) {
        nextOrder = [];
      } else {
        nextOrder = [[columnId, TABLE_SORTING_DIRECTION_ASC]];
      }
    }

    onRowSortOrderChangeInternal(nextOrder);

    if (onRowSortOrderChange) {
      onRowSortOrderChange(nextOrder);
    }
  }, [onRowSortOrderChange, rowSortOrderActual, onRowSortOrderChangeInternal, enableNeutralRowSorting, columnsSafe]);
  return {
    result: {
      rowSortOrder: rowSortOrderActual,
      onHeadCellClick: onHeadCellClick
    },
    restProps: restProps
  };
};